<div class="step-side-form-container">
  <div class="signup-form-container capture-methods">
    <div class="step-header">How will you send captures to Synced?</div>
    <div class="step-header-second">Pick any that fit — we'll set up each one for you. You can always change this later.</div>

    <div class="capture-methods__list">
      <app-selectable-card
        *ngFor="let m of methods"
        [title]="m.title"
        [description]="m.description"
        [selected]="isSelected(m.key)"
        (toggle)="toggle(m, $event)">
      </app-selectable-card>
    </div>

    <div class="capture-methods__actions">
      <button type="button" class="signup__btn-next"
              [disabled]="selected.size === 0 || saving"
              [class.disabled]="selected.size === 0 || saving"
              (click)="continue()">
        {{ saving ? 'Saving…' : 'Continue' }}
      </button>
    </div>
  </div>
</div>
